import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'goustouicomponents/dist/Alert'
import { Heading } from 'goustouicomponents/dist/Heading'
import DOMPurify from 'dompurify'
import parse from 'html-react-parser'
import { ContentLoader } from '../ContentLoader'
import css from './ArticleContent.module.css'

const ArticleContent = ({ isLoading, article = null }) => {
  if (article) {
    return (
      <>
        <Heading size="fontStyleXL">{article.title}</Heading>
        <div className={css.articleContent}>
          {parse(DOMPurify.sanitize(article.body))}
        </div>
      </>
    )
  }

  if (isLoading) {
    return <ContentLoader />
  }

  return (
    <Alert type="danger">
      <Heading type="h2" size="fontStyleM">Something went wrong!</Heading>
      <p>There is an issue fetching the content for this article.</p>
    </Alert>
  )
}

ArticleContent.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
}

export { ArticleContent }
